import React, { useEffect, useState } from 'react';

const Book = () => {
    return (
        <div className="Book">
            <h2>Читаем вместе</h2>
        </div>
    );
};

export default Book;
